import script from "./ButtonEventTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonEventTable.vue?vue&type=script&setup=true&lang=js"

import "./ButtonEventTable.vue?vue&type=style&index=0&id=f241ed40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f241ed40"]])

export default __exports__